<template lang="pug">
.crud
  .container-fluid.information__wrapper
    vm-row.heading(vm-w="12" vm-type="flex" vm-justify="space-between")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        vm-button(icon="arrow-back-outline" @click="$router.back()") {{ $t('strings.back') }}
    vm-row(vm-w="12" vm-type="flex" vm-justify="center")
      vm-col.card__wrapper(vm-sm=12 vm-md=6 vm-lg=12)
        vm-row(vm-align="left" vm-type="flex" vm-justify="left" vm-w="12")
          vm-col(vm-sm=12 vm-md=6 vm-lg=4 class="gutters")
            .card.card-primary
              .card-body
                h4 {{ $t('customers.tradename') }}
                h3  {{ customer.tradename }}
          vm-col(vm-sm=12 vm-md=6 vm-lg=4 class="gutters")
            .card
              .card-body
                h4 {{ $t('customers.assignmet_type_id') }}
                h3  {{ customer.assignmet_type.name }}
          vm-col(vm-sm=12 vm-md=6 vm-lg=4 class="gutters" v-if="customer.assigned_to")
            .card
              .card-body
                vm-row(vm-w="12" vm-type="flex" vm-justify="space-between")
                  vm-col(vm-sm=12 vm-md=5 vm-lg=4)
                    vm-row(vm-w="12" vm-type="flex" vm-justify="center" vm-align="center" class="h-100 p-0")
                      .icon__wrapper
                        vm-icon(icon="person-outline" size="1.5rem" color="#036683")
                  vm-col(vm-sm=12 vm-md=7 vm-lg=8)
                    h4 {{ $t('customers.assigned_to') }}
                    h3 {{ customer.seller.name }}
          vm-col(vm-sm=12 vm-md=6 vm-lg=3 class="gutters" v-else)
            .card
              .card-body
                h4 SIN VENDEDOR ASIGNADO
      vm-col.card__wrapper(vm-sm=12 vm-md=6 vm-lg=12)
        .card.card-flex2
          .card-body
            vm-table(max-height="350px" :data="customer.addresses" class="table")
              template(slot="header")
                h4 Direcciones del cliente
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsAddresses") {{ $t('customer_addresses.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsAddresses")
                    slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column == 'address_type_id'")  {{ nameType(data[indextr][column]) }}
                    slot(v-if="column != 'status' && column != 'created_at' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price' && column != 'address_type_id'") {{data[indextr][column]}}
      vm-col.card__wrapper(vm-sm=12 vm-md=6 vm-lg=12)
        .card.card-flex2
          .card-body
            vm-table(max-height="350px" :data="customer.contacts" class="table")
              template(slot="header")
                h4 Contactos del cliente
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsContacts") {{ $t('customer_contacts.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsContacts")
                    slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column != 'status' && column != 'created_at' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { required } from 'vuelidate/lib/validators'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'CustomerDetails',
  components: {},
  data: () => ({
    form: {},
    columnsAddresses: [
      'address_name',
      'street_name',
      'street_number',
      'city',
      'state',
      'country',
      'address_type_id'
    ],
    columnsContacts: [
      'name',
      'email',
      'phone',
      'ext',
      'cellphone',
      'position'
    ],
    status: [],
    touched: true,
    disabled: false
  }),
  validations: {
    form: {
      warehouse: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'customer',
      'customersCatalog'
    ])
  },
  watch: {
  },
  async created () {
    await this.loadCustomer({ id: this.$route.params.id })
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'loadCustomer',
      'loadCatalog'
    ]),
    nameType (code) {
      return this.customersCatalog.addressTypes.find(e => e.id === code)['name']
    },
    async getCatalog () {
      Object.keys(this.customersCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    }
  }
}
</script>

<style lang="scss" scoped>
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}

.con-vm-tooltip {
  display: inline-block;
  position: relative;
}

.vm-table--header {
  padding: 10px;

  span:nth-child(1) {
    width: 100%;
  }

  .input-select-con {
    span {
      width: auto !important;
    }
  }

  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }

      .vm-con-dropdown {
        float: left;
      }

      .con-select {
        display: inline-block;

        input {
          height: 32px;
        }
      }
    }
  }
}

.table {
  padding-left: 0 !important;

  .vm-table-text {
    padding-left: 0 !important;
  }
}

.information__wrapper {
  .card__wrapper {
    padding: 15px;
  }

  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;

    .card-body {
      padding: 10px !important;
      width: 100%;
      height: 100%;
    }
  }
}

.card-flex2 {
  position: relative;
  display: flex;
  flex-direction: column;
}

.card {
  padding: 10px !important;
  height: 100% !important;

  .card-body {
    padding: 10px !important;
    width: 100%;
    height: 100%;
  }
}

.heading_title {
  h4 {
    span {
      color: #026481;
    }
  }
}

.input__wrapper,
.actions__wrapper {
  justify-content: center;
  align-items: center;
}

.status__absolute {
  padding: 10px;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 0.5em;

  span {
    color: #fff;
    font-weight: bold;
  }
}

.input-shadow {
  border: 1px solid;
  border-radius: 0.3em;
}

.information__wrapper {
  margin-top: 25px;

  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;

    .card-body {
      padding: 10px !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .icon__wrapper {
        padding: 10px !important;
        border-radius: 0.5em;
        background-color: #dfdfdf;
      }
    }
  }
}

.card-primary {
  background: linear-gradient(to right, rgba(13, 67, 81, 1.5) 0%, rgba(13, 67, 81, 0.5) 100%) !important;
  color: #ffffff !important;
}

.floating_sale_amount {
  display: none;
}

@media screen and (min-width: 992px) {

  .floating_sale_amount,
  .floating_sub_unit_cost {
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 20px;
    left: 20px;
    background-color: #0082aa;
    padding: 10px;
    z-index: 20000;
    border-radius: 0.5em;

    span {
      color: #fff;
      padding: 10px;

      &:last-child {
        font-weight: bold;
      }
    }
  }
}

.floating_sub_unit_cost {
  bottom: 20px;
  left: calc(50% - 160.5px);
}

/* Globales */
h4 {
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 200;
  font-size: 1.1rem;
}

h3 {
  text-align: center;
  font-weight: bold;
  font-size: 1.3rem;
}

/* Helpers */
.gutters {
  padding: 20px;
}

.h-100 {
  height: 100%;
}

.p-0 {
  padding: 0 !important;
}
</style>
